import { render } from "./ImportSoA.vue?vue&type=template&id=64ff143f&scoped=true"
import script from "./ImportSoA.js?vue&type=script&lang=js"
export * from "./ImportSoA.js?vue&type=script&lang=js"

import "./ImportSoA.vue?vue&type=style&index=0&id=64ff143f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ff143f"]])

export default __exports__